import {dateTime} from "services/date";
import {QuizType} from "../../../types/QuizType";

/**
 * Transform the given quiz type by deserializing object properties
 *
 * @internal
 * @param quizType
 */
export default function deserializeQuizType(quizType: any): QuizType {
    quizType.created_at = dateTime(quizType.created_at)
    quizType.updated_at = dateTime(quizType.updated_at)

    return quizType;
}